import { Toast } from '@base-ui/react/toast'
import styled, { keyframes } from 'styled-components'

import { zIndex } from '@styles/tokens'

export const Viewport = styled(Toast.Viewport)`
  position: fixed;
  top: 24px;
  right: 24px;
  width: 356px;
  z-index: ${zIndex.toast};
  outline: none;

  @media (max-width: 600px) {
    top: 16px;
    right: 16px;
    left: 16px;
    width: auto;
  }
`

export const Content = styled(Toast.Content)`
  display: flex;
  align-items: center;
  gap: 6px;
  transition: opacity 400ms;

  &[data-behind]:not([data-expanded]) {
    opacity: 0;
  }
`

export const Close = styled(Toast.Close)`
  position: absolute;
  left: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translate(-35%, -35%);
  background: #fff;
  color: hsl(0, 0%, 9%);
  border: 1px solid hsl(0, 0%, 93%);
  border-radius: 50%;
  cursor: pointer;
  z-index: ${zIndex.toastClose};
  transition: opacity 400ms, background 200ms, border-color 200ms;

  &:hover {
    background: hsl(0, 0%, 97.3%);
    border-color: hsl(0, 0%, 90.9%);
  }

  &:focus-visible {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1), 0 0 0 2px rgba(0, 0, 0, 0.2);
  }
`

export const Card = styled(Toast.Root)`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: var(--toast-frontmost-height, auto);
  box-sizing: border-box;
  padding: 16px;
  border: 1px solid var(--border-neutral-faded, #dfe2ea);
  border-radius: 12px;
  background: var(--persistent-white, #fff);
  color: var(--foreground-neutral, #14171f);
  font-size: 14px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  outline: none;
  overflow-wrap: anywhere;
  touch-action: none;
  z-index: calc(${zIndex.toastStackBase} - var(--toast-index));
  transform: translateY(calc(var(--toast-index) * 14px)) scale(calc(1 - var(--toast-index) * 0.05));
  transition: transform 400ms, opacity 400ms, height 400ms, box-shadow 200ms;

  &[data-expanded] {
    height: var(--toast-height);
    transform: translateY(calc(var(--toast-offset-y) + var(--toast-index) * 14px));

    &::after {
      content: '';
      position: absolute;
      left: 0;
      top: 100%;
      width: 100%;
      height: 15px;
    }
  }

  &:not([data-expanded]):not(:first-child) ${Close} {
    opacity: 0;
  }

  &[data-starting-style],
  &[data-ending-style] {
    transform: translateY(-100%);
    opacity: 0;
  }

  &[data-limited] {
    opacity: 0;
    pointer-events: none;
  }

  &[data-swiping] {
    transform: translate(var(--toast-swipe-movement-x), var(--toast-swipe-movement-y));
    transition: none;
  }

  &:focus-visible {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1), 0 0 0 2px rgba(0, 0, 0, 0.2);
  }
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const Title = styled(Toast.Title)`
  margin: 0;
  font-size: inherit;
  font-weight: 500;
  line-height: 1.5;
`

export const Description = styled(Toast.Description)`
  margin: 0;
  font-weight: 400;
  line-height: 1.4;
  color: #3f3f3f;
`

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-left: -3px;
  margin-right: 4px;

  > svg {
    flex-shrink: 0;
    margin-left: -1px;
  }
`

const spin = keyframes`
  from { opacity: 1; }
  to { opacity: 0.15; }
`

export const Spinner = styled.div`
  width: 16px;
  height: 16px;
  position: absolute;
  inset: 0;

  > span {
    position: relative;
    top: 50%;
    left: 50%;
    display: block;
    width: 16px;
    height: 16px;
  }

  i {
    animation: ${spin} 1.2s linear infinite;
    background: hsl(0, 0%, 43.5%);
    border-radius: 6px;
    height: 8%;
    left: -10%;
    position: absolute;
    top: -3.9%;
    width: 24%;
    transform: translate(146%);
  }
`
